import { render } from "./AppFooter.vue?vue&type=template&id=4cb04671"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ginea/Desktop/template_demo/vuejs-tailwindcss-portfolio-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__